import { ServiceAppService } from './../../../../security/service-app.service';
import { ExportExcelService } from './../../../../shared/excel-service/export-excel.service';
import { FileUpload } from './../../../../shared/fileupload/fileupload';
import { DatePipe } from '@angular/common';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { Table } from 'primeng/table';

@Component({
  selector: 'app-tipo-item-lista',
  templateUrl: './tipo-item-lista.component.html',
  styleUrls: ['./tipo-item-lista.component.scss']
})

export class TipoItemListaComponent implements OnInit {

  cols: any[];

  first = 0;
  rows = 10;
  edit = false;

  dados: any[];
  enviaArquivo: any;

  _selectedColumns: any[];

  CategoriaFiltro = [];

  dado: any;
  selectedDados: any[];
  dadosExibicao = [];

  isCollapsed = true;
  tipoArquivo: any;
  loading: boolean;
  nomeModulo: string = 'Tipo Items';

  dadosDialog: boolean;
  submitted: boolean;
  dadosModal: boolean;

  codigos = [];
  categoriaItem = [];
  subgrupo = [];
  subgrupoSelecionar = [];
  categoriaItemSelecionar = [];
  selectedCategoriaItem = false;

  displayImport: boolean = false;
  displayFiltros: boolean = false;

  totalPercent = 0;
  progressBarPerc: any;
  percentDone: number;
  selectedFile: any;
  localUrl: any[];

  progress = false;
  dataInicio: Date;
  dataFim: Date;

  filtros = {
    codigo: null,
    categoriaItem: '',
    subgrupo: ''
  }

  @ViewChild('dt') dt: Table;
  @ViewChild('fileUploader') fileUpload: FileUpload;

  constructor(private confirmationService: ConfirmationService,
  private messageService: MessageService,
  private service: ServiceAppService,
  private config: PrimeNGConfig,
  private date: DatePipe,
  private exportExcelService: ExportExcelService) { }

  ngOnInit(): void {
    this.retornaDados();
    this.progressBarPerc = 0;

    this.cols = [
      { field: 'codigo', header: 'Código' },
      { field: 'categoriaItem', header: 'Categoria Item' },
      { field: 'subgrupo', header: 'Subgrupo' },
      { field: 'embalagem', header: 'Embalagem' },
      { field: 'classe', header: 'Classe' },
      { field: 'edit', header: 'Ações', width: '50px' }
    ];

    this.categoriaItemSelecionar = [
      { label: 'Peça', value: 'GEN' },
      { label: 'Roupa', value: 'CLO' },
      { label: 'Acessório', value: 'ACC' },
      { label: 'Autorizados', value: 'AUT' }
    ]

    this.subgrupoSelecionar = [
      { label: 'Óleo (MOTOR, TRANSMISSAO, ETC...)', value: 'LUB' },
      { label: 'Fluído Freio + Arrefecimento', value: 'QUI' },
      { label: 'PNEUS', value: 'PNE' },
      { label: 'Acessórios(HQ & DSH)', value: 'ACC' },
      { label: 'Baterias', value: 'BAT' },
      { label: 'Boutique', value: 'CLO' },
      { label: 'Peças originais', value: 'GEN' },
      { label: 'Personalização', value: 'PER' },
      { label: 'Estética', value: 'EST' },
      { label: 'Óleo', value: 'OLE' },
      { label: 'Químicos', value: 'QUI' },
    ]

    this.config.setTranslation({
      "startsWith": "Começa com",
      "contains": "Contém",
      "notContains": "Não Contém",
      "endsWith": "Termina com",
      "equals": "Igual",
      "notEquals": "Não é igual",
      "noFilter": "Sem Filtro",
      "lt": "Menor que",
      "lte": "Menos que ou igual a",
      "gt": "Maior que",
      "gte": "Mais que ou igual a",
      "dateIs": "Data é",
      "dateIsNot": "Data não é",
      "dateBefore": "Data é anterior a",
      "dateAfter": "Data é posterior a",
      "addRule": "Adicionar Regra",
      "removeRule": "Remover Regra",
      "apply": "Aplicar",
      "clear": "Limpar",
      "matchAll": "Combinar tudo",
      "matchAny": "Combinar com qualquer"
    });

    this._selectedColumns = this.cols;
  }

  @Input() get selectedColumns(): any[] {
    return this._selectedColumns;
  }

  set selectedColumns(val: any[]) {
    //restore original order
    this._selectedColumns = this.cols.filter(col => val.includes(col));
  }

  retornaDados(event?) {
    this.loading = true;
    this.service.getDados('/tipo_item').subscribe(res => {
      this.dados = res.dados;

      this.codigos = [];

      this.dados.forEach(usuario => {
        this.codigos.push({ label: usuario.codigo, value: usuario.codigo });
      });
      this.loading = false;
    });
  }

  recarregaDados() {
    this.dt.first = 0;

    this.retornaDados();
  }

  showDialog() {
    this.displayImport = true;
  }

  onSelectFile(event, uploader: FileUpload) {

    if (event && event.files) {
      this.totalPercent = event.files.length * 100;
      this.percentDone = 0;
      let i = 1;

      this.percentDone = i * 100;
      this.progressBarPerc = Math.round(this.percentDone / this.totalPercent * 100)
      i++;
    } else if (event == null && event.files == null) {
      this.progressBarPerc = 0;
    }
  }

  onUpload(event) {
    this.progress = true;
    const file = event.files[0];
    const formData = new FormData();

    formData.append("file", file);

    if (event.files[0].name) {
      this.messageService.add({ key: 'tipoItem', severity: 'info', summary: 'Importando...', detail: 'Aguarde o termino da importação, pode fechar a tela e voltar mais tarde!', life: 4000 });
    }

    this.service.postArquivoItem('/tipo_item/upload', formData).subscribe({
      next: (response) => {
        if (response.sucesso == true) {
          this.messageService.add({ key: 'tipoItem', severity: 'success', summary: `${response.erros[0].coluna}`, detail: `${response.erros[0].mensagem}`, life: 5000 });
          this.progress = false;

        } else if (response.sucesso == false && response.tipoErro == 1) {
          response.erros.forEach((erro: any) => {
            this.messageService.add({ key: 'tipoItem', severity: 'error', summary: `Linha ${erro.linha}`, detail: `Coluna ${erro.coluna}: ${erro.mensagem}`, life: 5000 });
          });

          this.progress = false;

        } else if (response.sucesso == false && response.tipoErro == 2) {
          response.erros.forEach((erro: any) => {
            this.messageService.add({ key: 'tipoItem', severity: 'error', summary: `${erro.coluna}`, detail: `${erro.mensagem}`, life: 5000 });
          });

          this.progress = false;
        }

        this.retornaDados();
      }
    });
  }

  progressReport(event) {
    this.fileUpload.progress = event;
  }

  onRemoveFile(event?) {
    this.progressBarPerc = 0;
  }

  removeFile(file: File, uploader: FileUpload) {
    const index = uploader.files.indexOf(file);
    uploader.remove(null, index);
  }

  processarArquivo(dado) {
    this.confirmationService.confirm({
      message: 'Tem certeza que deseja processar o arquivo?',
      header: 'Confirmar',
      icon: 'pi pi-exclamation-triangle',
      key: 'importacaoArquivoHonda',
      acceptLabel: 'Sim',
      rejectLabel: 'Não',
      accept: () => {
        const formData = new FormData();

        formData.append("id", dado.id.toString());

        this.dados.forEach(dados => {
          if (dados.id == dado.id) {
            dados.status = 2;
          }
        });
      }
    });
  }

  showFiltrosAvancados() {
    this.displayFiltros = true;
  }

  hideFiltrosAvancados() {
    this.displayFiltros = false;
  }

  filtrosAPI() {
    if (this.filtros.codigo != '') {
      this.dt.filter(this.filtros.codigo, 'codigo', 'equals');
    } else {
      this.dt.filter('', 'codigo', 'equals');
    }

    if (this.filtros.categoriaItem != '') {
      this.dt.filter(this.filtros.categoriaItem, 'categoriaItem', 'equals');
    } else {
      this.dt.filter('', 'Categoria', 'equals');
    }

    if (this.filtros.subgrupo != '') {
      this.dt.filter(this.filtros.subgrupo, 'subgrupo', 'contains');
    } else {
      this.dt.filter('', 'subgrupo', 'contains');
    }

    this.retornaDados();
  }

  limpafiltros(event) {
    this.filtros = {
      codigo: null,
      categoriaItem: '',
      subgrupo: ''
    }

    this.dt.filter('', 'codigo', 'equals');
    this.dt.filter('', 'categoriaItem', 'equals');
    this.dt.filter('', 'subgrupo', 'equals');

    //this.tratarData();
    this.retornaDados();
  };

  saveDados() {
    this.submitted = true;

    // Verifica se campo(s) estão preenchidos
    if (typeof this.dado.categoriaItem === "undefined") {
      this.messageService.add({ key: 'categoriaItem', severity: 'error', summary: 'Erro', detail: 'Dados não preenchidos', life: 3000 }); return;
    }

    // Verifica se for inserção ou alteracão
    if (this.edit) {
      this.service.putDados('/tipo_item', {
        "codigo": this.dado.codigo,
        "categoriaItem": this.dado.categoriaItem,
        "subgrupo": this.dado.subgrupo,
        "embalagem": this.dado.embalagem,
        "classe": this.dado.classe
      }).subscribe(res => {
        if (res.sucesso == false && res.tipoErro == 1) {
          res.erros.forEach((erro: any) => {
            this.messageService.add({ key: 'tipoItem', severity: 'error', summary: `Dados não salvos`, detail: `Campo obrigatório "${erro.coluna}" está vazio`, life: 5000 });
          });
        }
        else if (res.sucesso == true) {
          this.messageService.add({ key: 'categoriaItem', severity: 'success', summary: 'Sucesso', detail: 'Dados Alterado', life: 3000 });
          this.retornaDados();
        }
      });
      this.edit = false;
      this.dadosDialog = false;
      return;
    }

    this.dadosDialog = false;
  }

  editDados(dado) {
    this.edit = true;
    this.dado = { ...dado };
    this.dadosDialog = true;
    this.selectedCategoriaItem = true;
  }

  //Paginator
  next() {
    this.first = this.first + this.rows;
  }

  prev() {
    this.first = this.first - this.rows;
  }

  reset() {
    this.first = 0;
  }

  isLastPage(): boolean {
    return this.dados ? this.first === (this.dados.length - this.rows) : true;
  }

  isFirstPage(): boolean {
    return this.dados ? this.first === 0 : true;
  }

  hideDialog() {
    this.dadosDialog = false;
  }
exportExcel() {
  const registros = this.dt && this.dt.filteredValue
    ? this.dt.filteredValue
    : this.dados;

  if (!registros || registros.length === 0) {
    this.messageService.add({
      key: 'tipoItem',
      severity: 'warn',
      summary: 'Atenção',
      detail: 'Não existem registros para exportar.',
      life: 3000
    });
    return;
  }

  this.exportExcelService.nomeModulo = this.nomeModulo;

  this.exportExcelService.ExportTOExcelJSON(registros.map(r => {
    let linha = {};

    this._selectedColumns.forEach(c => {
      if (c.field !== 'edit') {
        linha[c.header] = r[c.field] != null ? r[c.field] : '';
      }
    });

    return linha;
  }));
}
}